import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PostgrestBuilder } from './types';
import PostgrestFilterBuilder from './PostgrestFilterBuilder';

var PostgrestRpcBuilder = /*#__PURE__*/function (_PostgrestBuilder) {
  _inherits(PostgrestRpcBuilder, _PostgrestBuilder);

  var _super = _createSuper(PostgrestRpcBuilder);

  function PostgrestRpcBuilder(url) {
    var _this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers,
        schema = _ref.schema,
        fetch = _ref.fetch,
        shouldThrowOnError = _ref.shouldThrowOnError;

    _classCallCheck(this, PostgrestRpcBuilder);

    _this = _super.call(this, {
      fetch: fetch,
      shouldThrowOnError: shouldThrowOnError
    });
    _this.url = new URL(url);
    _this.headers = Object.assign({}, headers);
    _this.schema = schema;
    return _this;
  }
  /**
   * Perform a function call.
   */


  _createClass(PostgrestRpcBuilder, [{
    key: "rpc",
    value: function rpc(params) {
      var _this2 = this;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$head = _ref2.head,
          head = _ref2$head === void 0 ? false : _ref2$head,
          _ref2$count = _ref2.count,
          count = _ref2$count === void 0 ? null : _ref2$count;

      if (head) {
        this.method = 'HEAD';

        if (params) {
          Object.entries(params).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                name = _ref4[0],
                value = _ref4[1];

            _this2.url.searchParams.append(name, value);
          });
        }
      } else {
        this.method = 'POST';
        this.body = params;
      }

      if (count) {
        if (this.headers['Prefer'] !== undefined) this.headers['Prefer'] += ",count=".concat(count);else this.headers['Prefer'] = "count=".concat(count);
      }

      return new PostgrestFilterBuilder(this);
    }
  }]);

  return PostgrestRpcBuilder;
}(PostgrestBuilder);

export { PostgrestRpcBuilder as default };